import {createGlobalStyle} from 'styled-components';
import openSansRegular from 'url:../assets/fonts/open-sans-regular.woff2';
import openSansMedium from 'url:../assets/fonts/open-sans-medium.woff2';
import openSansSemiBold from 'url:../assets/fonts/open-sans-semi-bold.woff2';
import openSansBold from 'url:../assets/fonts/open-sans-bold.woff2';
import helveticaneuecyrBold from 'url:../assets/fonts/helveticaneuecyr-bold.ttf';
import {rootElement} from './config';

const Font = {
    OPEN_SANS: 'var(--font-open-sans)',
};

const GlobalFonts = createGlobalStyle`
    @font-face {
        font-family: 'Open Sans';
        font-weight: 400;
        font-style: normal;
        font-display: swap;
        src: url(${openSansRegular});
    }

    @font-face {
        font-family: 'Open Sans';
        font-weight: 500;
        font-style: normal;
        font-display: swap;
        src: url(${openSansMedium});
    }

    @font-face {
        font-family: 'Open Sans';
        font-weight: 600;
        font-style: normal;
        font-display: swap;
        src: url(${openSansSemiBold});
    }

    @font-face {
        font-family: 'Open Sans';
        font-weight: 700;
        font-style: normal;
        font-display: swap;
        src: url(${openSansBold});
    }

    @font-face {
        font-family: 'HelveticaNeueCyr';
        font-weight: 700;
        font-style: normal;
        font-display: swap;
        src: url(${helveticaneuecyrBold});
    }

    ${rootElement} {
        --font-open-sans: 'Open Sans', Arial, sans-serif;
    }
`;

export {Font, GlobalFonts};
